import { cloneElement, useEffect } from "react";
import {
  NewConnectionProvider,
  useNewConnectionContext,
} from "../context/NewConnectionContext";
import { useLocation, useParams } from "wouter";
import { fetchFullConnectionDetails } from "../services/ApiService";
import toast from "react-hot-toast";
import { ApplicationInfoProvider } from "../context/ApplicationInfoContext";
import StepIndicator from "../components/StepIndicator";
import { useWizardSteps } from "../hooks/useWizardSteps";
import {
  WIZARD_STEP_COMPONENTS,
  WIZARD_TOTAL_STEPS,
  getWizardSkipIndices,
} from "./NewConnection/wizardConfig";

const UpdateConnection = () => {
  const [, setLocation] = useLocation();
  const params = useParams();
  const connectionId = params.connectionId
    ? parseInt(params.connectionId)
    : null;

  const { newConnectionData, dispatch } = useNewConnectionContext();

  useEffect(() => {
    if (!connectionId) {
      console.warn("No valid connection ID provided");
      return setLocation("/koppelingen");
    }

    let isMounted = true;

    (async () => {
      try {
        const details = await fetchFullConnectionDetails(connectionId);
        if (!isMounted) return;

        dispatch({ type: "LOAD_EXISTING_CONNECTION", payload: details });
      } catch (error) {
        console.error("Error loading connection details", error);
        if (isMounted) {
          toast.error("Fout bij het laden van de koppeling");
          setLocation("/koppelingen");
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps -- listing this would re-run the effect on changes it should ignore
  }, [connectionId, dispatch]);

  const skipIndices = getWizardSkipIndices(newConnectionData.mappings);
  const { currentStepIndex, highestVisitedIndex, goToStep, goBack, goNext } =
    useWizardSteps(WIZARD_STEP_COMPONENTS.length, skipIndices);

  const stepIndicator = (
    <StepIndicator
      totalSteps={WIZARD_TOTAL_STEPS}
      currentIndex={currentStepIndex}
      highestVisitedIndex={highestVisitedIndex}
      onStepClick={goToStep}
    />
  );

  const StepComponent = cloneElement(WIZARD_STEP_COMPONENTS[currentStepIndex], {
    handleButtonBackClick: goBack,
    handleButtonNextClick: goNext,
    stepIndicator,
  });

  return <div>{StepComponent}</div>;
};

const UpdateConnectionWrapper = () => {
  return (
    <ApplicationInfoProvider>
      <NewConnectionProvider>
        <UpdateConnection />
      </NewConnectionProvider>
    </ApplicationInfoProvider>
  );
};

export default UpdateConnectionWrapper;
